import React, { useRef, useState, useEffect } from 'react';
import '../css/wb_customize_campaigns.css'

import Papa from 'papaparse';
import ShowSnackBar from "../components/snackBar";

import { apiCall } from '../services/authServieces';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import dayjs from 'dayjs';
dayjs.extend(localizedFormat);

const WbCustomizeCampaigns = () => {
// let csvdata=[];
const [snackBar, setSnackBar] = useState({open: false, severity: true,message: ""});


    const [Campaign,setCampaign]=useState('')
    const fileInputRef = useRef(null);// for opening csv file
    const [csvHeaders, setCsvHeaders] = useState([]); // for csv file headers
    const [fileName, setFileName] = useState('No File Selected'); // for csv filename
    const [message, setMessage] = useState('');// for message
    const [remainingChars, setRemainingChars] = useState(800);//limit for characts
    const [totalContact,settotalContact]=useState('0');
    const [templatetype,settemplatetype]=useState('');
    const [template,settemplate]=useState('');
    const [fileType, setFileType] = useState('');
    const [templatedata, setemplatedata] = useState([]);
    const [templateID, settemplateID] = useState('');
    const [templatename, settemplatename] = useState('');
    const [templatecat, settemplatecat] = useState('');
    const [templatelang, settemplatelang] = useState('');
    const [msgUrl,setmsgUrl]=useState('');
    const [filed,setfiledata]=useState();
    const [showModal, setShowModal] = useState(false);
    const [mobileno,setmobileno]=useState('');
    const [loading, setLoading] = useState(false);
    const [modaltotalContacts,setmodaltotalContacts]=useState('0')
    const [maindata,setmaindata]=useState();
    const [variabledata,setvariabledata]=useState([]);

    const [modalData, setModalData] = useState([]);  
    const [variableclick, setvariableclick] = useState(''); 
    
    const [pltPrice, setpltPrice] = useState('');
    const [msgPrice, setmsgPrice] = useState('');
    const [userBalance, setuserBalance] = useState('');
    const [finalvalue, setfinalvalue] = useState('');

    const [contactdata, setcontactdata] = useState([]);
    // const [businessNo, setbusinessNo] = useState('');
    const [blockNum,setblockNum]=useState([]);
    
    const checkfiledata = useRef(null);
    const checkurldata = useRef(null);
    
  const [dataObject, setDataObject] = useState({});//for globally use data
  const [botName, setBotName] = useState([]);
  const [botNameData, setBotNameData] = useState([]);
  
  const [dateTimeButton, setDateTimeButton] =useState('ExpDateTime')
  const [msgExpCheckbox, setMsgExpCheckbox] =useState(false)

  const [expDateTime, setExpDateTime] = useState(null);
  const [expTime, setExpTime] = useState(null);

  const [selectedColumns, setSelectedColumns] = useState([]);
  

  const handleMsgExpCheckbox = () => {
    setMsgExpCheckbox((prevState) => !prevState); 
  };
  
  const handleExpiryDTBtn=(event)=>{
    setDateTimeButton(event.target.value)
    if(event.target.value==='ExpDateTime'){
      setExpTime(null)      
    }else if(event.target.value==='ExpTime'){
      setExpDateTime(null)            
    }
  }

    const handleImportClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    useEffect(() => {
      // Call the function to fetch contact data
      Handleblocknodata();
      Contactdata();
      botNameDataFunc()
    }, []);
  

    const Handleblocknodata=async()=>{
      try{
  
        let response = await apiCall({ endpoint: 'api/get_block_number_data', method: 'get' });
  
        if(response.success===true){
  
          let blocknumdata=response.data.map(item=>item.block_number)
  
          setblockNum(blocknumdata)
      
        }else{
          setblockNum([])
  
        }
      
     
  
  
      }catch(err){
  
  console.log('error in fechting blocknodata',err)
      }
  
    }

    const handleFileChange = (event) => {
   
        const fileUpload = event.target.files[0];


        setmaindata(fileUpload)

        if (fileUpload && fileUpload.name) {

            setFileName(fileUpload.name)
            const reader = new FileReader();
            reader.onload = (e) => {
                const csvContent = e.target.result;

                Papa.parse(csvContent, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        let parsedData = results.data;

                        // Extract headers from CSV
                        const headers = results.meta.fields;
                        setCsvHeaders(headers);

                        // Limit the processing to 50,000 rows
                        const MAX_ROWS = 50000;
                        if (parsedData.length > MAX_ROWS) {
                            parsedData = parsedData.slice(0, MAX_ROWS);
                            alert(`Only the first ${MAX_ROWS} rows will be processed.`);
                        }
    // Initialize the dataObject with empty arrays for each header
    let newDataObject = {};
    headers.forEach(header => {
        newDataObject[header] = [];
    });

    // Populate the newDataObject with CSV data
    parsedData.forEach(row => {
        headers.forEach(header => {
            if (row[header] !== undefined) {
                newDataObject[header].push(row[header]);
            }
        });
    });

    // Update state with new dataObject
    setDataObject(newDataObject);


                        settotalContact(prev=> prev=parsedData.length)
                    }
                });
            };
            reader.readAsText(fileUpload);
        }
    };


     // Get Businesss number //
  const Contactdata = async () => {
    try {
      let response = await apiCall({ endpoint: 'api/get-business-no', method: 'get' });

      if (response.data && response.data.length > 0) {
        // Extract business_no from each object in the array
        const businessNumbers = response.data.map(item => item.business_no);

        // Set the extracted business numbers to contactdata
        setcontactdata(businessNumbers);
      } else {
        setcontactdata([]); // Clear the contact data if no data is returned
      }
    } catch (error) {
      console.error('Error fetching contact data:', error);
      setcontactdata([]); // Clear the contact data in case of an error
    }
  };
     // Get Businesss number //
  const botNameDataFunc = async () => {
    try {
      let response = await apiCall({ endpoint: 'api/get-bot-name', method: 'get' });
  
      if (response.data && response.data.length > 0) {
        const resBotNames = response.data.map(item => item.bot_name);
        // console.log('resBotNames: ', resBotNames);
        setBotNameData(resBotNames);
      
      } else {
        setBotNameData([]); 
      }
    } catch (error) {
      console.error('Error fetching contact data:', error);
      setBotNameData([]); // Clear the contact data in case of an error
    }
  };


//   const handleHeaderClick = (e) => {
//     const selectedColumns = Array.from(e.target.selectedOptions).map(option => option.value);
//     if (selectedColumns.length === 0) return;

//     const textarea = document.getElementById("Message");
//     if (!textarea) return;

//     // Get current cursor position from textarea instead of previous state
//     const start = textarea.selectionStart;
//     const currentMessage = textarea.value; // Get current message from textarea
//     let newMessage = currentMessage;

//     // Find all bracket pairs in the current text
//     const brackets = [];
//     let openBracket = -1;
    
//     for (let i = 0; i < currentMessage.length; i++) {
//         if (currentMessage[i] === '[') {
//             openBracket = i;
//         } else if (currentMessage[i] === ']' && openBracket !== -1) {
//             brackets.push({
//                 start: openBracket,
//                 end: i,
//                 content: currentMessage.slice(openBracket, i + 1)
//             });
//             openBracket = -1;
//         }
//     }

//     // Find if cursor is directly inside any bracket pair
//     let selectedBracket = null;
    
//     for (const bracket of brackets) {
//         // Only select if cursor is strictly between [ and ]
//         if (start > bracket.start && start < bracket.end) {
//             selectedBracket = bracket;
//             break;
//         }
//     }

//     // Only proceed if cursor is directly inside brackets
//     if (selectedBracket) {
//         // Replace only the content within the selected brackets
//         newMessage = 
//             currentMessage.substring(0, selectedBracket.start + 1) + 
//             selectedColumns.join("][") +
//             currentMessage.substring(selectedBracket.end);

//         // Update the textarea value and state
//         textarea.value = newMessage;
//         setMessage(newMessage);
//         setRemainingChars(maxChars - newMessage.length);

//         // Move the cursor to the end of the inserted text
//         const newCursorPos = selectedBracket.start + selectedColumns.join("][").length + 1;
//         textarea.selectionStart = newCursorPos;
//         textarea.selectionEnd = newCursorPos;
//         textarea.focus();
//     }
// };





//     const handleHeaderClick = (header) => {
       
// //       let msg=message;

// // msg=msg.replace('{{'+variableclick+'}}','{{'+header+'}}')

// // setMessage(msg)

//       // setMessage((prevMessage) => prevMessage + `{{${header}}}`);  // Append selected header to the message area

//     };


    // const maxChars = 1024;
    // const handleMessageChange = (e) => {
    //     let inputText = e.target.value;

    //     // If input exceeds 800 characters, trim it
    //     if (inputText.length > maxChars) {
    //         inputText = inputText.substring(0, maxChars);
    //     }

    //     // Update the message state and calculate remaining characters
    //     setMessage(inputText);
    //     setRemainingChars(maxChars - inputText.length);
    
    // };

    const handleFileTypeChange=async(e)=>{

        const selectedFileType = e.target.value;

        settemplatetype(selectedFileType);
        setFileType(selectedFileType);


        try{

            const payload={'templatetype':selectedFileType,
              'requesttype':'Customize'
            }

            const response = await apiCall({ endpoint: 'api/gettemplate_data_custom', method: 'POST', payload: payload })

            if (response.data && response.data) {

                // Mapping the response to an array of template names or any other format you need
                const templateOptions = response.data.map(item => ({
                  name: item.templatename,
                  id: item.id
                }));
        
                // Setting the template data
                setemplatedata(templateOptions);

            }else{
                setemplatedata([])

            }

        }catch(err){

            setemplatedata([])
        }
    


    }


    const handletemplatename = async (e) => {

        try {
    

          let selectedTempName = e.target.value;
    
          let payload = {
            "selectedTempName": selectedTempName
          }
    
    
          const responsemsg = await apiCall({ endpoint: 'getresponse_msg', method: 'POST', payload: payload })

          console.log(responsemsg,'responsemsg')
   
          settemplatename(responsemsg?.data?.temp_name)
          settemplatecat(responsemsg?.data?.cat)
          settemplatelang(responsemsg?.data?.lang)
          setuserBalance(responsemsg?.totaldata?.balance)

          
          setpltPrice(responsemsg?.balancedata?.template_platform_cost);
          setmsgPrice(responsemsg.balancedata?.template_cost)
    
          settemplateID(responsemsg?.data?.temp_id)
    
          settemplate(selectedTempName)
    
          setMessage('')


          function extractVariables(msg) {
            let matches = msg.match(/{{(.*?)}}/g);
            return matches ? matches.map(v => v.replace(/[{{}}]/g, '')) : [];
        }

        // let msg=responsemsg.data.message;

        let msg=responsemsg.balancedata.card_description;


        let extractvariable=extractVariables(msg)

          setvariabledata(extractvariable);
    
          setMessage(responsemsg.balancedata.card_description);
    
    
    
    
        } catch (err) {
    
          console.log(err)
        }
      }



      const SendData = async (event) => {
        event.preventDefault();
        if (Campaign.trim() === '') {
            return alert('Please Enter Campaign Title');
          }
        if (mobileno.trim() === '') {
            return alert('Please Select file Mobile No');
          }

        // if (fileType !== 'Text' && msgUrl.trim() === '' && !filed) {
        //     return alert('Please Enter a Media URL or Upload a File');
        //   }

        if (template.trim()==='') {
            return alert('Please Select Template');
         }

        if (message.trim() === '') {
            return alert('Please Enter a Message');
          }
      
        // console.log('botName:', botName)
        if (!botName) {
          return alert('Please Select Bot Name');
        }
  

  



        //console.log(filteredVariables,'filteredVariables')
        let data=dataObject[mobileno]


        data=data.filter(number => !blockNum.includes(number))

        let mobiledata=data;
        var contactlength=data.length

        let sendMsgprice = (Number(pltPrice) + Number(msgPrice)) *contactlength;
        
        let finalsendprice = parseFloat(sendMsgprice);

        let finaluserBal = parseFloat(userBalance);

        if (finalsendprice > finaluserBal) {
          return alert('Your Balance is Low');
        }
    
        let datafinal = sendMsgprice;
    
        setfinalvalue(prevval => prevval = datafinal)




        // if (data.length > 5) {
            data = data.slice(0, 5);
        // }

        // let finalMessages = []
        // for (let i = 0; i < data.length; i++) {
        //     let mymsg = message;
        //     for (let j = 0; j < filteredVariables.length; j++) {
        //         mymsg = mymsg.replace('{{' + filteredVariables[j] + '}}', dataObject[filteredVariables[j]][i]);
        //     }
    
        // // Push message and mobile number to the finalMessages array
        // finalMessages.push({
        //     mobile: data[i],
        //     message: mymsg,
        //     length: mymsg.length
        // });
        // }

        // setModalData(finalMessages);
        setmodaltotalContacts(contactlength);
        setShowModal(true);

      }

      const handleSendNow=async()=>{
        setLoading(true); // Start loader

        try{

            const formData = new FormData();

            formData.append('template_id',templateID);
            formData.append('template_name',template);
            formData.append('template_lang',templatelang);
            formData.append('template_cat',templatecat);
            formData.append('message',message);
            // formData.append('dataObject', JSON.stringify(dataObject));
            formData.append('mobile_colmn',mobileno)
            formData.append('campaigntitle',Campaign)
            // formData.append('msgUrl',msgUrl)
            formData.append('msgtype', fileType);

            formData.append('totalmsgprice', finalvalue)
            // formData.append('businessNo', businessNo)

            // maincsv file data start
            formData.append('mainfiledata',maindata);
            // maincsv file data end
            
            formData.append('botName',botName);
            // formData.append('expDateTime', expDateTime)
            // formData.append('expTime', expTime)

            // if (filed) {
            //     formData.append('file', filed);
            //   }

              const response = await apiCall({
                endpoint: 'api/save_wb_customize_message',
                method: 'POST',
                payload: formData
              });


   if (response?.success === true) {

        alert("Data Send Successfull")

       window.location.reload();
        // Clear the form or show a success message here if needed
      }




        } catch (error) {
      
          console.log(error,'error')

             alert("Data Send Successfull")

       window.location.reload();

          // setSnackBar({
          //   open: true,
          //   severity: error?.response?.data?.success ? true : false,  // If it's an object, this will be forced to a boolean
          //   message: typeof error?.response?.data?.message === 'string' ? error?.response?.data?.message : "An error occurred",  // Ensure message is a string
          // });

      // if any error in sending data
      setLoading(false);
      
          } finally {


            setLoading(false); // Reload the page after success or error
          }


      }


      const handleCloseSnackBar = () => {
        setSnackBar((prevState) => ({ ...prevState, open: false }));
      };

      const handleColumnInsert = (column) => {
        const textarea = document.getElementById("Message");
        if (!textarea) return;
    
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
    
        setMessage((prev) => {
            return prev.substring(0, start) + `[${column}]` + prev.substring(end);
        });
    
        // Move cursor after the inserted column placeholder
        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = start + `[${column}]`.length;
            textarea.focus();
        }, 0);
    };
    

  return (
    <>
    <div className="WB_customize_contain">
    <h4 className="Head_title">Customize Campaign</h4>
    <div className="Customize_card">
        <p>To Mobile Number <span className='required_icon'>*</span></p>
        <div className="custm_docs">
            <p>Every column should have column name</p>
            <p>You can Upload data in batches of 50,000 at a time Only .csv file are allowed.</p>
            <h4>File Name : {fileName}</h4>
            <button type="button" onClick={handleImportClick}>Browse Document</button>
        </div>
        <p>Total Contact : <span>{totalContact}</span></p>

        <div className="row gy-3">
            <div className="col-lg-6">
                <div className="form_group11">
                    <label htmlFor="title">Campaign Title <span className='required_icon'>*</span></label>
                    <input type="text" id="title" placeholder="Enter Campaign Title" value={Campaign} onChange={e=>setCampaign(e.target.value)}/>  
                </div>
            </div>
            <div className="col-lg-3">
                <div className="form_group11">
                    <label htmlFor="number">Mobile Number <span className='required_icon'>*</span></label>
                    <select  id="number" value={mobileno} onChange={e=>setmobileno(e.target.value)}>
                    <option value="">None</option>
                {csvHeaders.length > 0 ? (
                    csvHeaders.map((header, index) => (
                        <option key={index} value={header}>{header}</option>
                    ))
                ) : (
                    ''
                )}
                    </select>   
                </div>
            </div>
           <div className="col-lg-3">
                <div className="form_group11">
                  <label htmlFor="botName">
                    Bot Name <span className="required_icon">*</span>
                  </label>
                  <select id="botName" value={botName} onChange={e=>setBotName(e.target.value)}>
                    <option value="">None</option>
                    {/* <option value="Bot1">Bot1</option> */}
                    {botNameData.map((row, index) => (
                      <option key={index} value={row}>
                        {row}
                      </option>
                    ))}
                  </select>
                </div>
            </div>


        </div>
        <div className="row gy-3 mt-1">
            <div className="col-lg-6">
                <div className="form_group11">
                    <label htmlFor="template type">Template Type <span className='required_icon'>*</span></label>
                    <select  id="templatetype" value={templatetype} onChange={handleFileTypeChange}>
                        <option >None</option>
                        <option value="rich_card">Rich Card Stand Alone</option>
                  <option value="carousel">Rich Card Carousel</option>
                  <option value="text_message">Text Message</option>
                  <option value="text_message_with_pdf">Text Message with PDF</option>
                    </select>
                </div>
            </div>
            <div className="col-lg-6">
                <div className="form_group11">
                    <label htmlFor="template" value={template}>Template <span className='required_icon'>*</span></label>
                    <select  id="template" onChange={handletemplatename}>
                        <option >None</option>
                        {templatedata.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                    </select>
                </div>
            </div>
         

            <div className="col-12">
                <div className="form_group11 mt-0 text-center">
                    <button type="button" onClick={SendData}>Send SMS</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div className={`modal fade  ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="Sms_privew_modal" aria-hidden={!showModal}>
            <div className="modal-dialog">
                <div className="modal-header">
                  <h5 className="modal-title text-center w-100" id="Sms_privew_modal">Confirmation</h5>
                </div>
              <div className="modal-content Campaigns_Modal_contain">
                <div className="modal-body p-0">
                <p>Are you sure you want to start the campaign “{Campaign}”?

Please press Send Now to continue with the campaign "{Campaign}" ,
press Close to go back and make changes.</p>
                  <div className="form_group1 mt-3 text-center">
                    <button type="button" disabled={loading} onClick={handleSendNow} className={loading ? 'd-none Modal_save_btn' : 'Modal_save_btn'}>
                      {loading ? 'Sending...' : 'Send Now'}
                    </button>
                    <button type="button" className={loading ? '' : 'd-none'} disabled={loading}>
                    {loading ? 'Sending... ' : ''}
                    </button>
                    <button type="button" className="Modal_cancel_btn ms-2" onClick={() => setShowModal(false)} aria-label="Close">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

{/* template id */}
<input
        type="hidden"
        value={templateID}
        className='d-none' 
      />
{/* template name */}
      <input
        type="hidden"
        value={templatename}
        className='d-none' 
      />

{/* template category */}
      <input
        type="hidden"
        value={templatecat}
        className='d-none' 
      />

{/* template language  */}

      <input
        type="hidden"
        value={templatelang}
        className='d-none' 
      />


      {/* for main file */}

<input
        type="file"
        ref={fileInputRef}
        className='d-none'
        onChange={handleFileChange}
        accept='.csv'
      />

        <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
      
    </>
  )
}

export default WbCustomizeCampaigns
